import PropTypes from 'prop-types';
import { memo } from 'react';
import { EmailLink } from '../common/sharelinks/EmailLink.tsx';
import { FacebookLink } from '../common/sharelinks/FacebookLink.tsx';
import { FacebookMessengerLink } from '../common/sharelinks/FacebookMessengerLink.tsx';
import { ClickToCopy } from '../common/sharelinks/ClickToCopy.tsx';

let TeacherStatsShareBar = function ({ secureBaseURL, facebookAppId, getTafEmail, getTrackingLink, shareURL, getTafURL }) {
    const fullShareURL = `${secureBaseURL}${shareURL}`;
    return (<div>
        <h4 className="teacher-share-headline">Share your Page:</h4>
        <ul className="teacher-stats-share-buttons share-wrapper">
            <li>
                <FacebookLink
                    className="button-facebook heap-facebook-share"
                    urlToShare={fullShareURL}
                    pageName={pageName}
                    getTrackingLink={getTrackingLink}
                    facebookAppId={facebookAppId}
                />
            </li>
            <li>
                <EmailLink
                    className="button-email heap-email-share"
                    secure={false}
                    tafURL={getTafURL('TeacherStats')}
                    pageName={pageName}

                    getTafEmail={getTafEmail}
                    onEmailClick={() => {}}
                />
            </li>
            <li>
                <FacebookMessengerLink
                    className="button-facebook icon-messenger heap-messenger-share"
                    urlToShare={fullShareURL}
                    getTrackingLink={getTrackingLink}
                    facebookAppId={facebookAppId}
                    pageName={pageName}
                />
            </li>
            <li>
                <ClickToCopy
                    buttonClassName="icon icon-ss-link"
                    textToCopy={fullShareURL}
                    getTrackingLink={getTrackingLink}
                    pageName={pageName}
                    indicatorClassName="hover-tooltop-wrapper"
                />
            </li>
        </ul>
    </div>);
};

TeacherStatsShareBar.propTypes = {
    secureBaseURL: PropTypes.string,
    facebookAppId: PropTypes.string,
    getTafEmail: PropTypes.func.isRequired,
    getTafURL: PropTypes.func.isRequired,
    getTrackingLink: PropTypes.func.isRequired,
    shareURL: PropTypes.string,
};

TeacherStatsShareBar = memo(TeacherStatsShareBar);
export default TeacherStatsShareBar;
